import { render, staticRenderFns } from "./ShopCart.vue?vue&type=template&id=5ae00e08&scoped=true&"
import script from "./ShopCart.vue?vue&type=script&lang=js&"
export * from "./ShopCart.vue?vue&type=script&lang=js&"
import style0 from "./ShopCart.vue?vue&type=style&index=0&id=5ae00e08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae00e08",
  null
  
)

export default component.exports